import { gql } from "@apollo/client";

export const QUERY_MESSAGES = gql`
  query {
    users {
      id
      email
      roleIds
      userAdminDistrictIds
      userAdminSchoolIds
      userGeneralSchoolIds
      hidden
    }
  }
`;

export const QUERY_MESSAGE = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      email
      roleIds
      userAdminDistrictIds
      userAdminSchoolIds
      userGeneralSchoolIds
      hidden
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;
